import React, {PureComponent, Fragment} from "react"
import {InjectedIntl} from "react-intl"

import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"

import {StyledButton, StyledValidationButton, Flex, StyledIcon} from "./styled"
import {LoadingWrapper} from "../shared"

interface Props extends InjectedIntl {
  onBack: () => void
  onContinue: () => void
  load?: any
}

class ContinueBackButtons extends PureComponent<Props> {
  render() {
    const {onBack, onContinue, load, formatMessage} = this.props
    return (
      <Fragment>
        <Flex>
          <StyledButton large full onClick={onBack}>
            <StyledIcon icon="backArrow" />
            <FormattedMessage id="medical.global.buttons.back" />
          </StyledButton>
          <StyledValidationButton
            primary
            large
            full
            load={load}
            loading={formatMessage({id: "medical.global.buttons.loading"})}
            onClick={onContinue}>
            <FormattedMessage id="medical.global.buttons.continue" />
          </StyledValidationButton>
        </Flex>
        <LoadingWrapper>
          <Loading load={load} useLoader={false} />
        </LoadingWrapper>
      </Fragment>
    )
  }
}

export default injectIntl(ContinueBackButtons)
